import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { Pulse as SpotlightPulse } from '@atlaskit/onboarding/target';
import { fg } from '@confluence/feature-gating';

import { useDiscoverabilityPulse } from './useDiscoverabilityPulse.ts';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';
import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

type DiscoverabilityPulseProps = {
	children: JSX.Element;
	entryPointId: string;
	isCircle?: boolean;
};

export const DiscoverabilityPulse = ({
	children,
	entryPointId,
	isCircle,
}: DiscoverabilityPulseProps): JSX.Element => {
	const { isPulseActive } = useDiscoverabilityPulse(entryPointId);

	if (!isPulseActive) {
		return children;
	}

	// Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	if (fg('confluence_frontend_spotlight_ads_migration')) {
		return (
			<PopoverProvider>
				<PopoverTarget>{children}</PopoverTarget>
			</PopoverProvider>
		);
	}

	return (
		<SpotlightPulse radius={isCircle ? 24 : 3} testId="loom-cross-sell-discoverability-pulse">
			{children}
		</SpotlightPulse>
	);
};
